"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleButtonGroupItem = exports.ToggleButtonGroup = void 0;
const ToggleGroupPrimitive = __importStar(require("@radix-ui/react-toggle-group"));
const React = __importStar(require("react"));
const utils_1 = require("../../lib/utils");
const ToggleButton_1 = require("./ToggleButton");
const ToggleButtonGroupContext = React.createContext({
    size: "md",
});
const ToggleButtonGroup = React.forwardRef(({ className, size, children, ...props }, ref) => (React.createElement(ToggleGroupPrimitive.Root, { ref: ref, className: (0, utils_1.cn)("tw-flex tw-items-center tw-justify-center tw-gap-1", className), ...props },
    React.createElement(ToggleButtonGroupContext.Provider, { value: { size } }, children))));
exports.ToggleButtonGroup = ToggleButtonGroup;
ToggleButtonGroup.displayName = "ToggleButtonGroup";
const ToggleButtonGroupItem = React.forwardRef(({ className, children, size, ...props }, ref) => {
    const context = React.useContext(ToggleButtonGroupContext);
    return (React.createElement(ToggleGroupPrimitive.Item, { ref: ref, className: (0, utils_1.cn)((0, ToggleButton_1.toggleButtonVariants)({
            size: context.size || size,
        }), className), ...props }, children));
});
exports.ToggleButtonGroupItem = ToggleButtonGroupItem;
ToggleButtonGroupItem.displayName = "ToggleButtonGroupItem";
